import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  plus310ted5e4i90h as plus,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { httpHeaders1p0c4h1mvk3o7 as httpHeaders } from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  webSockettc1n59zaskoq as webSocket,
  RequestBodyTextpvofjwd95b3y as RequestBodyText,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import { get_DefaultJson7vbyrb403mrj as get_DefaultJson } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/serialization.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  _Duration___get_inWholeMilliseconds__impl__msfiry33sjnw92ish9p as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { StringArrayFormat1xi667mcf8p4h as StringArrayFormat } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringArrayFormat.mjs';
import {
  get_kiteUi2m7u81n0o8zpz as get_kiteUi,
  toClientWebSocketu5uqzcygbetr as toClientWebSocket,
} from './adapt.mjs';
import { connectivityFetch17pa0p5vdf435 as connectivityFetch } from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch-connectivity.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import {
  Companion_instancezswcp2r1mhj0 as Companion_instance,
  LSError2xrpo13ez2d1 as LSError,
} from '../../../../../lightning-server-core-shared/com/lightningkite/lightningserver/LSError.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../LsErrorException.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  retryWebSocket1zhkddxzq5149 as retryWebSocket,
  typedkoq3bdobhtfj as typed,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/wsretry.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function asPath($this, $receiver) {
  return startsWith($receiver, '/') ? $receiver : '/' + $receiver;
}
function ConnectivityFetcher$_init_$slambda_9bjaak() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  }), 0);
}
function ConnectivityFetcher$invoke$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return httpHeaders(plus(listOf(to('Accept', 'application/json')), yield* $(this$0.calculator_1($completion), $completion)));
  }), 0);
}
function ConnectivityFetcher$webSocket$slambda$lambda(it) {
  return it.first_1 + '=' + it.second_1;
}
function ConnectivityFetcher$webSocket$slambda(this$0, $url) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    var headers = yield* $(this$0.calculator_1($completion), $completion);
    var base = this$0.ws_1 + asPath(this$0, $url);
    var tmp;
    if (headers.isEmpty_y1axqb_k$()) {
      tmp = base;
    } else {
      var separator = contains(base, _Char___init__impl__6a9atx(63)) ? _Char___init__impl__6a9atx(38) : _Char___init__impl__6a9atx(63);
      var tmp_0 = base + toString(separator);
      tmp = tmp_0 + joinToString(headers, '&', VOID, VOID, VOID, VOID, ConnectivityFetcher$webSocket$slambda$lambda);
    }
    return webSocket(tmp);
  }), 0);
}
var ConnectivityFetcherClass;
function ConnectivityFetcher() {
  if (ConnectivityFetcherClass === VOID) {
    class $ {
      constructor(http, ws, json, pingTime, calculator) {
        json = json === VOID ? get_DefaultJson() : json;
        var tmp;
        if (pingTime === VOID) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          tmp = toDuration(5000, DurationUnit_MILLISECONDS_getInstance());
        } else {
          tmp = pingTime;
        }
        pingTime = tmp;
        var tmp_0;
        if (calculator === VOID) {
          tmp_0 = ConnectivityFetcher$_init_$slambda_9bjaak();
        } else {
          tmp_0 = calculator;
        }
        calculator = tmp_0;
        this.http_1 = http;
        this.ws_1 = ws;
        this.json_1 = json;
        this.pingTime_1 = pingTime;
        this.calculator_1 = calculator;
        this.stringArrayFormat_1 = new (StringArrayFormat())(this.json_1.get_serializersModule_piitvg_k$());
      }
      withHeaderCalculator_vab9hb_k$(calculator) {
        return new (ConnectivityFetcher())(this.http_1, this.ws_1, this.json_1, this.pingTime_1, calculator);
      }
      *invoke_vgogw6_k$(url, method, inSerializer, body, outSerializer, $completion) {
        var tmp = this.http_1 + asPath(this, url);
        var tmp_0 = get_kiteUi(method);
        // Inline function 'kotlin.let' call
        var it = yield* connectivityFetch(tmp, tmp_0, ConnectivityFetcher$invoke$slambda(this), !(inSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === 'kotlin.Unit') ? new (RequestBodyText())(this.json_1.encodeToString_k0apqx_k$(inSerializer, body), 'application/json') : null, $completion);
        var tmp_1;
        if (!it.get_ok_kntnrv_k$()) {
          var text = yield* it.text_7k3n3e_k$($completion);
          var tmp_2;
          try {
            var e = this.json_1.decodeFromString_jwu9sq_k$(Companion_instance.serializer_9w0wvi_k$(), text);
            tmp_2 = LsErrorException().new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(e);
          } catch ($p) {
            var tmp_3;
            if ($p instanceof Exception()) {
              var e_0 = $p;
              tmp_3 = LsErrorException().new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(new (LSError())(it.get_status_jnf6d7_k$(), 'Unknown', text));
            } else {
              throw $p;
            }
            tmp_2 = tmp_3;
          }
          throw tmp_2;
        } else {
          if (outSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === 'kotlin.Unit')
            return Unit_instance;
          var tmp_4;
          try {
            tmp_4 = this.json_1.decodeFromString_jwu9sq_k$(outSerializer, yield* it.text_7k3n3e_k$($completion));
          } catch ($p_0) {
            var tmp_5;
            if ($p_0 instanceof SerializationException()) {
              var e_1 = $p_0;
              // Inline function 'kotlin.also' call
              var this_0 = SerializationException().new_kotlinx_serialization_SerializationException_pjmzgo_k$('Failed to parse ' + outSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ' from response', e_1);
              printStackTrace(this_0);
              throw this_0;
            } else {
              throw $p_0;
            }
          }
          tmp_1 = tmp_4;
        }
        return tmp_1;
      }
      webSocket_nkn44m_k$(url, inSerializer, outSerializer) {
        return toClientWebSocket(typed(retryWebSocket(ConnectivityFetcher$webSocket$slambda(this, url), _Duration___get_inWholeMilliseconds__impl__msfiry(this.pingTime_1)), this.json_1, inSerializer, outSerializer));
      }
      url_tsvlb2_k$(value, serializer) {
        return this.stringArrayFormat_1.encodeToString_k0apqx_k$(serializer, value);
      }
    }
    initMetadataForClass($, 'ConnectivityFetcher', VOID, VOID, VOID, [5]);
    ConnectivityFetcherClass = $;
  }
  return ConnectivityFetcherClass;
}
//region block: exports
export {
  ConnectivityFetcher as ConnectivityFetcher3s7vafe801t1v,
};
//endregion

//# sourceMappingURL=ConnectivityFetcher.mjs.map
